import { Title } from '@components/atoms/Title';
import InputForm from '@components/atoms/Input/Input';
import { Button, Footer } from '@components/atoms';
import { Label } from '@components/atoms/Label';
import { useAddAccount } from './useAddAccount';
import { popupError, urlZaf } from '@services/Zendesk';
import { FieldRenderer, SearchExistingUsers } from '@components/organism';
import { useAllFieldsForms } from '@hooks/useAllFieldsForms';
import { formatRole } from '@hooks/masks';
import { GoPencil } from 'react-icons/go';

export function AddAccount() {
  const account = useAddAccount();
  const allFields = useAllFieldsForms(account);
  return (
    <div className="p-4">
      <Title
        title="• Adicionar conta"
        subtitle={`Preencha os dados da conta do tipo ${account.selectedRole ? formatRole(account.selectedRole) : ''}`}
      />

      <div className="flex flex-col gap-2 mt-6">
        <SearchExistingUsers
          searchTerm={account.searchTerm}
          setSearchTerm={account.setSearchTerm}
          users={account.users}
          loading={account.loading}
          noUsers={account.noUsers}
          searchUsers={account.searchUsers}
          selectExistingUser={account.selectExistingUser}
          linkUser={false}
        />

        <div className="border-t border-gray-200 my-4"></div>
        {account.selectedRole !== 'titular_da_nf' && (
          <div className="flex flex-col gap-4 h-100 overflow-y-auto max-h-[calc(100vh-450px)]" key={account.selectedRole}>
            <Label title="Ou preencha os dados para criar uma nova conta" />

            {allFields.map((field) => {
              if (field.customField) {
                return (
                  <>
                    <div key={field.id}>
                      <FieldRenderer
                        key={field.id}
                        field={field as any}
                        value={field.value}
                        onChange={field.onChange as any}
                        maxLength={
                          {
                            endereco_2: 60,
                            cpf_3: 14,
                          }[field.key as string]
                        }
                        className={`${account.invalidFields[field.key as keyof typeof account.invalidFields]
                          ? 'border-red-500 focus:border-red-500'
                          : 'border-gray-300'
                          }`}
                        onCopy={account.onCopy}

                      />
                      {account.invalidFields[field.key as keyof typeof account.invalidFields] && (
                        <span className="text-red-500 text-sm">
                          Campo {field.title} É obrigatório
                        </span>
                      )}
                      {field.key === 'endereco_2' && (
                        <p className="text-gray-500 text-sm">
                          {field.value ? field.value.length : 0}/60 caracteres
                        </p>
                      )}
                    </div>
                  </>
                );
              } else {
                return (
                  <div key={field.id}>
                    <Label title={field.title} />
                    <InputForm
                      type={field.type}
                      name={field.key}
                      value={field.value as string}
                      onChange={(e) => field.onChange(e.target.value)}
                      onCopy={account.onCopy}
                      className={`${account.invalidFields[field.key as keyof typeof account.invalidFields]
                        ? 'border-red-500 focus:border-red-500'
                        : 'border-gray-300'
                        }`}
                      maxLength={
                        {
                          phone: 10,
                          endereco_2: 60,
                          cpf_3: 14,
                        }[field.key as string]
                      }
                      onKeyPress={(e) => {
                        if (field.key === 'cpf_3') {
                          if (!/^[0-9.-]$/.test(e.key)) {
                            e.preventDefault();
                          }
                        }
                      }}
                    />
                    {account.invalidFields[field.key as keyof typeof account.invalidFields] && (
                      <span className="text-red-500 text-sm">
                        Campo {field.title} é obrigatório
                      </span>
                    )}
                    {field.key === 'cpf_3' && account.cpfError && (
                      <p className="text-red-500 text-sm mt-1">{account.cpfError}</p>
                    )}
                    {field.key === 'cnpj_regex' && account.cnpjError && (
                      <p className="text-red-500 text-sm mt-1">{account.cnpjError}</p>
                    )}
                    {field.key === 'cpf_3' && account.existUserCpfFormatted && (
                      <p className="text-gray-500 text-sm mt-1">
                        Usuário com CPF formatado:{' '}
                        <a
                          href={`${urlZaf}/users/${account.existUserCpfFormatted.id}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-blue-600 underline text-sm"
                        >
                          {account.existUserCpfFormatted.name}
                        </a>
                                                <button
                            title="Editar"
                            className="text-green-600 cursor-pointer py-2 flex-1 text-center ml-2"
                            onClick={() => {
                              const tipoContaToSet = (account.selectedRole === 'revenda' || account.selectedRole === 'posto') 
                                ? 'pessoa_juridica' 
                                : account.tipoContas;
                              
                              account.setSelectedUser({
                                ...account.existUser,
                                role: account.selectedRole || '',
                                user_fields: {
                                  ...account.existUser?.user_fields,
                                  tipo_de_conta: tipoContaToSet || null
                                }
                              } as any);
                              account.navigate(`/edit-user/${account.existUser?.id}`);
                            }}
                          >
                           Editar usuário <GoPencil className="inline-block" />
                          </button>
                      </p>
                    )}

                    {field.key === 'cpf_3' && account.existUser && (
                      <p className="text-gray-500 text-sm mt-1">
                        Usuário com CPF sem formatação:{' '}
                        <a
                          href={`${urlZaf}/users/${account.existUser.id}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-blue-600 underline text-sm"
                        >
                          {account.existUser.name} -  
                        </a>
                        <button
                            title="Editar"
                            className="text-green-600 cursor-pointer py-2 flex-1 text-center ml-2"
                            onClick={() => {
                              const tipoContaToSet = (account.selectedRole === 'revenda' || account.selectedRole === 'posto') 
                                ? 'pessoa_juridica' 
                                : account.tipoContas;
                              
                              account.setSelectedUser({
                                ...account.existUser,
                                role: account.selectedRole || '',
                                user_fields: {
                                  ...account.existUser?.user_fields,
                                  tipo_de_conta: tipoContaToSet || null
                                }
                              } as any);
                              account.navigate(`/edit-user/${account.existUser?.id}`);
                            }}
                          >
                           Editar usuário <GoPencil className="inline-block" />
                          </button>
                      </p>
                    )}
                    {field.key === 'email' && account.emailError && (
                      <p className="text-red-500 text-sm mt-1">{account.emailError}</p>
                    )}
                    {field.key === 'email' && account.existUserEmail && (
                      <p className="text-gray-500 text-sm mt-1">
                        Usuário encontrado:{' '}
                        <a
                          href={`${urlZaf}/users/${account.existUserEmail.id}`}
                          target="_blank"
                          className="text-blue-600 underline text-sm mt-1"
                        >
                          {account.existUserEmail.name}
                        </a>
                      </p>
                    )}
                  </div>
                );
              }
            })}
          </div>
        )}
      </div>
      {account.selectedRole !== 'titular_da_nf' && (
        <div className="fixed bottom-0 left-0 w-full bg-white p-4 border-t border-gray-200">
          <Footer>
            <div className="flex gap-3 flex-col">
              <Button
                isStretched
                isPrimary
                onClick={() => {
                  if (account.isButtonDisabled) {
                    account.setShowErrors(true);
                    popupError(`Preencha todos os campos obrigatórios`, true);
                    return;
                  }
                  account.prepareNewUser();
                }}
              >
                Prosseguir
              </Button>
              <Button isStretched onClick={() => account.navigate('/')}>
                Voltar
              </Button>
            </div>
          </Footer>
        </div>
      )}

    </div>
  );
}
